import { apiClient } from '@/lib/api/client';
import type {
  DashboardMetricsResponse,
  DashboardChartsResponse,
  DashboardRankingsResponse,
} from '../types/dashboard.types';

export const dashboardService = {
  /**
   * Get dashboard metrics for a date range
   */
  async getMetrics(startDate: string, endDate: string): Promise<DashboardMetricsResponse> {
    const response = await apiClient.get<DashboardMetricsResponse>('/dashboard/metrics', {
      params: {
        startDate,
        endDate,
      },
    });
    return response.data;
  },

  /**
   * Get dashboard chart data
   */
  async getCharts(monthsBack: number = 6): Promise<DashboardChartsResponse> {
    const response = await apiClient.get<DashboardChartsResponse>('/dashboard/charts', {
      params: {
        monthsBack,
      },
    });
    return response.data;
  },

  /**
   * Get dashboard rankings data
   */
  async getRankings(topN: number = 5): Promise<DashboardRankingsResponse> {
    const response = await apiClient.get<DashboardRankingsResponse>('/dashboard/rankings', {
      params: {
        topN,
      },
    });
    return response.data;
  },
};
